import * as React from "react";
import moment from "moment";

import styled from 'styled-components';
// icons
import "font-awesome/css/font-awesome.min.css";

// styling
import "bootstrap/dist/css/bootstrap.min.css";

// toast
import "react-toastify/dist/ReactToastify.css";

// flags
import "flag-icon-css/css/flag-icon.css";

import "rc-steps/assets/index.css";
import "rc-steps/assets/iconfont.css";

import Steps, { Step } from "rc-steps";
import { IoMdClose } from "react-icons/io";
import Modal from "react-awesome-modal";
import { Scrollbars } from 'react-custom-scrollbars';

import Vimeo from "../../components/VimeoPlayer/VimeoPlayer.Component";


import withServices from '../../HOCs/withServices';

// services
import {
  createItemGen,
  currentBaseUrl,
  currentDesignation,
  currentUser,
  currentUserId,
  getGeneralDirect,
  getGeneralSmartTableData,
  isUserLoggedIn,
  currentLesson,
  setCurrentLessonAttempt
} from "../../common/services";

// components

import NavBar from "../../components/CustomNav/CustomNav.Component";

// loader
import SimpleLoader from "../../common/simpleLoader.Component";

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer } from "react-toastify";

// tabs
import { Col } from "reactstrap";

// contants
import { APIBASE, MEDIABASE } from "../../common/constants";

// video player
import { Player, BigPlayButton } from "video-react";
import "node_modules/video-react/dist/video-react.css";

// page specific styling
import { CSSTransition } from "react-transition-group";
import "./lessonPreview.css";

import Loader from "react-loader";

// interactions
import RecallInteraction from "../../components/RecallInteraction/RecallInteraction.Component";
import DragDropInteraction from "../../components/DnDInteraction/DragDropInteraction.Component";
import MultipleChoiceInteraction from "../../components/MultipleChoiceInteraction/MultipleChoiceInteraction.Component";
import MultipleChoiceMultiInteraction from "../../components/MultipleChoiceMultiInteraction/MultipleChoiceMultiInteraction.Component";

// utils
import { processRedWords } from "../../common/utils";

import CustomCalendar from "../../common/Lessons/customCalendar.Component";

import { tourSteps } from "./LessonViewTour";
import Tour from "reactour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import VideoPlayer from "src/components/VideoPlayer/VideoPlayer";

const PreviewRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  div {
    margin-right: 16px;
  }
`;
const AssetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.alignment ? props.alignment : "flex-start")};
  justify-content: center;
  max-width: ${(props) => props.assetWidth}%;
  width: ${(props) => props.assetWidth}%;
  min-width: ${(props) => props.assetWidth}%;
  padding: 8px;
`;
const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  background-color: ${(props) => props.bgColor};
  color: #fff;
  width: 100%;
  min-height: 600px;
  min-width: 600px;
  height: 100%;
  padding: 32px 32px;
`;

interface IProps {
  history: any;
  services: any;
}

class LessonViewPage extends React.Component<IProps> {
  public state = {
    background: "#0000",
    baseurl: currentBaseUrl(),
    currentinteractiondata: {} as any,
    currentscreen: {},
    currentscreenidx: 0,
    color: "#0000",
    destination: "",
    draft: "",
    editorState: "",
    font: "Anton",
    htmltext: "",
    lesson: {} as any,
    loaded: false,
    mounted: false,
    navigate: false,
    screens: [] as any[],
    tologin: false,
    username: "",
    reschedule: false,
    openExitModal: false,
    interactionLoading: false,
    processingmodal: false,

    // pdf render
    numPages: null,
    chooseTutorEnabled: false, // future use - enabling/disabling choosing a tutor
    // openModal: false,

    // rescheduling lesson in modal state
    openScheduleModal: false,
    allocations: [],
    events: [] as any,
    guidesRead: true,
    downloadableFiles: [] as any,
    sessionKey: "",
  };

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.loadScreenData = this.loadScreenData.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    // this.handleReschedule = this.handleReschedule.bind(this);
    this.handleChooseTutor = this.handleChooseTutor.bind(this);
    this.interactionComplete = this.interactionComplete.bind(this);
    this.goBack = this.goBack.bind(this);
    this.onStepClick = this.onStepClick.bind(this);
    this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
    // this.toggleModal = this.toggleModal.bind(this);
    this.closeScheduleModal = this.closeScheduleModal.bind(this);
    this.openScheduleModal = this.openScheduleModal.bind(this);
    this.getEventIndex = this.getEventIndex.bind(this);
    this.handleAllocationsLoaded = this.handleAllocationsLoaded.bind(this);
    this.handleRequestCompleted = this.handleRequestCompleted.bind(this);
    this.onDragStop = this.onDragStop.bind(this);
    this.handleLessonLoaded = this.handleLessonLoaded.bind(this);
    this.closeExitModal = this.closeExitModal.bind(this);
    this.exitPage = this.exitPage.bind(this);
  }

  public onLogout(arg) {
    this.setState({ tologin: true });
  }

  // public toggleModal() {
  //   const modalstate = this.state.openModal;
  //   this.setState({ openModal: !modalstate });
  // }
  public openScheduleModal() {
    // get lesson allocations
    getGeneralSmartTableData("overview/lesson_allocations", (text) =>
      this.handleAllocationsLoaded(text)
    );
  }

  public closeScheduleModal() {
    this.setState({ openScheduleModal: false });
  }
  public closeExitModal() {
    this.setState({ openExitModal: false });
  }
  public currentid() {
    const key1 = "match";
    return this.props[key1].params.id;
  }

  public getEndTime(dateString, duration) {
    const date = new Date(dateString);
    date.setHours(date.getHours() + duration);
    return date;
  }
  public getEventIndex(array, attr, val) {
    for (let i = 0; i < array.length; i++) {
      if (array[i][attr] === val) {
        return i;
      }
    }
    return -1;
  }
  public onDragStop(args) {
    const currentEvent = args.data;
    const events = this.state.events;
    const prevEvtIdx = this.getEventIndex(
      events,
      "LessonId",
      currentEvent.LessonId
    );
    // const lessonId = currentEvent.LessonId;
    const lessonidx = currentEvent.Id;
    const item = {
      Time: currentEvent.StartTime.getTime() / 1000,
    };
    if (
      events[prevEvtIdx].StartTime < new Date() ||
      currentEvent.StartTime < new Date()
    ) {
      toast.error("You Cannot Change The Past!");
      this.setState({ events });
    } else {
      createItemGen(
        "lesson_allocations/" + lessonidx + "/reschedule/",
        item,
        (text) => this.handleRequestCompleted(text, events)
      );
    }
  }
  public generatePreviewAsset = (asset, idx, rowId, columns) => {
    if (asset === null) {
      return <p style={{ width: "100%" }} />;
    } else {
      if (asset.type === "image") {
        return (
          <AssetWrapper
            assetWidth={Math.round(100 / columns)}
            alignment={this.getAlignment(asset.align)}
            key={`${rowId}-${idx}`}
          >
            <img
              src={asset.content}
              style={{ width: `${asset.size}px` }}
              alt="img"
            />
          </AssetWrapper>
        );
      }
      if (asset.type === "icon") {
        return (
          <AssetWrapper
            assetWidth={Math.round(100 / columns)}
            alignment={this.getAlignment(asset.align)}
            key={`${rowId}-${idx}`}
          >
            <img
              src={asset.content}
              style={{ width: `${asset.size}px` }}
              alt="icon"
            />
          </AssetWrapper>
        );
      }
      if (asset.type === "text") {
        return (
          <div
            style={{
              maxWidth: `${Math.round(100 / columns)}%`,
              width: "100%",
              padding: "8px",
            }}
            key={`${rowId}-${idx}`}
            dangerouslySetInnerHTML={{ __html: asset.content }}
          />
        );
      }

      if (asset.type === "video") {
        return (
          <AssetWrapper
            assetWidth={Math.round(100 / columns)}
            alignment={this.getAlignment(asset.align)}
            key={`${rowId}-${idx}`}
          >
            <video
              src={asset.content}
              style={{ width: `${asset.size}px` }}
              controls={true}
            />
          </AssetWrapper>
        );
      }
    }
    return;
  };
  public getAlignment = (align) => {
    if (align === "left") {
      return "flex-start";
    }
    if (align === "center") {
      return "center";
    }
    if (align === "right") {
      return "flex-end";
    }
    return;
  };
  public handleAllocationsLoaded(res) {
    if (res.code === 200) {
      const tempevents = [] as any;
      for (const curritem of res.response.lessonallocations) {
        const evt = {
          Id: curritem.id,
          Subject: curritem.Title,
          StartTime: new Date(curritem.DueDate),
          EndTime: this.getEndTime(curritem.DueDate, curritem.Duration),
          LessonId: curritem.LessonId,
        };
        tempevents.push(evt);
      }
      const modalstate = this.state.openScheduleModal;
      this.setState({
        allocations: res.response.lessonallocations,
        events: tempevents,
        openScheduleModal: true,
      });
    }
  }
  public handleRequestCompleted(res, prevevents) {
    if (res.code === 200) {
      getGeneralSmartTableData("overview/lesson_allocations", (text) =>
        this.handleAllocationsLoaded(text)
      );
      toast.success("Reschedule Successful");
      this.setState({ openScheduleModal: true });
    } else {
      toast.error("Sorry, request failed");
      this.setState({
        events: prevevents,
      });
    }
  }


  public async loadScreenData() {
    const keyid = "id";
    const keyscreentype = "ScreenType";
    const currentscreen = this.state.screens[this.state.currentscreenidx];

    this.setState({ currentscreen });

    if (currentscreen[keyscreentype] === 0) {
      console.log("Content Screen");
    } else if (currentscreen[keyscreentype] === 1) {

      this.setState({ processingmodal: true });

      const res = await this.props.services.studentsAPI.getLessonScreen(this.currentid(), currentscreen[keyid]);

      if (res.ok) {

        console.log(res.data);

        this.setState({
          processingmodal: false,
          currentinteractiondata: res.data.screen.interaction,
        });

      } else {
        toast.error("Error finding interactions!");
      }
    }
  }



  public openWidget(param, e) {
    this.setState({ destination: currentBaseUrl() + param });
    this.setState({ navigate: true });
  }

  public async componentDidMount() {
    if (!isUserLoggedIn()) {
      this.setState({ tologin: true });
    } else {

      const currentlesson = currentLesson();

      const attemptRes = await this.props.services.studentsAPI.createLessonAttempt(this.currentid(), {
        allocation_id: currentlesson.id,
        session_key: currentlesson.sessionKey
      });

      if (attemptRes.ok) {
        console.log(attemptRes.data)
      } else {
        toast.error("Error fetching lesson data, please go back to lesson list and try again");

        return;
      }

      const ScreensRes = await this.props.services.studentsAPI.getLessonScreenList(this.currentid());

      if (ScreensRes.ok) {
        console.log("Screen Data Okay")
      } else {
        toast.error("Error fetching lesson data, please go back to lesson list and try again");

        return;
      }

      // fix screens order bug - sort screens using DisplayOrder
      const screens = ScreensRes.data.screens;
      screens.sort((a, b) => a.DisplayOrder - b.DisplayOrder);

      this.setState({ loaded: true });
      this.setState({ screens, lesson: ScreensRes.data.lesson_info });

      await this.loadScreenData();

    }
    const tourStatus = localStorage.getItem(
      `${this.props.services.currentUsername}LessonViewTour`
    );
    let guidesRead = true;
    if (tourStatus === null) {
      guidesRead = false;
    }

    const pdfRes = await this.props.services.adminAPI.getLessonDownloadableFile(this.currentid());
    let downloadableFiles = new Array();
    if (pdfRes.ok) {
      downloadableFiles = pdfRes.data.pdfs;
    }

    this.setState({ username: currentUser(), mounted: true, guidesRead, downloadableFiles });
  }

  public closeTour = () => {
    localStorage.setItem(
      `${this.props.services.currentUsername}LessonViewTour`,
      "true"
    );
    this.setState({ guidesRead: true });
  };

  public disableBody = (target) => {
    disableBodyScroll(target);
  };
  public enableBody = (target) => {
    enableBodyScroll(target);
  };

  public handlePopState(event) {
    event.preventDefault();
    event.returnValue = "";
  }
  public handleLessonLoaded(res) {
    this.setState({ lesson: res.response });
  }

  public shouldComponentUpdate(nextState) {
    if (this.state.openScheduleModal === nextState.openScheduleModal) {
      return false;
    } else {
      return true;
    }
  }

  public handleAttemptLoaded(res) {
    if (res.code === 200) {
      setCurrentLessonAttempt(res.response);
    }
  }

  public async nextPage() {
    if (this.state.currentscreenidx < this.state.screens.length - 1) {

      const newval = this.state.currentscreenidx + 1;
      this.setState({ currentscreenidx: newval });
      setTimeout(this.loadScreenData, 100);
      // await this.loadScreenData();
    } else if (this.state.currentscreenidx === this.state.screens.length - 1) {
      // finished all preview screens
      this.setState({
        destination: currentBaseUrl() + "congratulations",
        navigate: true,
      });
    }
  }

  public previousPage() {
    if (this.state.currentscreenidx > 0) {
      const newval = this.state.currentscreenidx - 1;
      this.setState({ currentscreenidx: newval });
      setTimeout(this.loadScreenData, 100);
    }
  }

  public interactionComplete() {
    this.nextPage();
  }

  public onStepClick(currentscreenidx) {
    this.setState({ currentscreenidx });
    setTimeout(this.loadScreenData, 100);
  }

  public onDocumentLoadSuccess(val) {
    this.setState({ numPages: val });
  }

  public showInteraction() {
    if (this.state.processingmodal) {
      return <p>Loading Interaction Data</p>;
    }
    if (this.state.currentinteractiondata === {}) {
      return <p>No Interaction Data</p>;
    } else {
      if (this.state.currentinteractiondata.interaction_type === "choice") {
        if (this.state.currentinteractiondata.choice_type === "single_choice") {
          return (
            <MultipleChoiceInteraction
              oncomplete={this.interactionComplete}
              demomode={false}
              show={true}
              lessonid={this.currentid()}
              interactionid={this.state.currentinteractiondata.id}
              completiontext={this.state.currentinteractiondata.completion_text}
              submittext={"Submit"}
              introtext={this.state.currentinteractiondata.intro_text}
              question={this.state.currentinteractiondata.question_text}
              answers={this.state.currentinteractiondata.choices}
              penalty={this.state.currentinteractiondata.penalty}
              timelimit={this.state.currentinteractiondata.time_limit}
            />
          );
        } else {
          return (
            <MultipleChoiceMultiInteraction
              oncomplete={this.interactionComplete}
              demomode={false}
              show={true}
              lessonid={this.currentid()}
              interactionid={this.state.currentinteractiondata.id}
              completiontext={this.state.currentinteractiondata.completion_text}
              submittext={"Submit"}
              introtext={this.state.currentinteractiondata.intro_text}
              question={this.state.currentinteractiondata.question_text}
              answers={this.state.currentinteractiondata.choices}
              penalty={this.state.currentinteractiondata.penalty}
              timelimit={this.state.currentinteractiondata.time_limit}
            />
          );
        }
      } else if (
        this.state.currentinteractiondata.interaction_type === "draganddrop"
      ) {
        return (
          <DragDropInteraction
            oncomplete={this.interactionComplete}
            demomode={false}
            show={true}
            lessonid={this.currentid()}
            interactionid={this.state.currentinteractiondata.id}
            completiontext={this.state.currentinteractiondata.completion_text}
            submittext={"Submit"}
            introtext={this.state.currentinteractiondata.intro_text}
            dragquestions={this.state.currentinteractiondata.options}
            penalty={this.state.currentinteractiondata.penalty}
            timelimit={this.state.currentinteractiondata.time_limit}
          />
        );
      } else if (
        this.state.currentinteractiondata.interaction_type === "recall"
      ) {
        return (
          <RecallInteraction
            oncomplete={this.interactionComplete}
            demomode={false}
            show={true}
            lessonid={this.currentid()}
            interactionid={this.state.currentinteractiondata.id}
            completiontext={this.state.currentinteractiondata.completion_text}
            submittext={"Submit"}
            introtext={this.state.currentinteractiondata.intro_text}
            question={this.state.currentinteractiondata.paragraph_copy}
            redwords={processRedWords(
              this.state.currentinteractiondata.recall_words
            )}
            penalty={this.state.currentinteractiondata.penalty}
            timelimit={this.state.currentinteractiondata.time_limit}
          />
        );
      }

      return <Loader />;
    }
  }

  public screendisplay2(currentscreen) {
    if (this.state.screens.length > 0) {
      const keyscreentype = "ScreenType";
      const keyvideourl = "VideoUrl";
      const keydisplaydata = "DisplayData";

      if (currentscreen.length < 1) {
        return <Loader />;
      }
      // if current screen type is content
      if (currentscreen[keyscreentype] === 0) {
        // first page
        const { LessonScreenId } = currentscreen;
        const { rows, rowOrder } = currentscreen.DisplayData;
        if (this.state.currentscreenidx === 0) {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <PreviewContainer
                  bgColor={currentscreen[keydisplaydata].background}
                >
                  <React.Fragment>
                    {rowOrder.map((rowId, idx) => {
                      const row = rows[rowId];
                      const assets = row.assets;

                      return (
                        <PreviewRow key={`${LessonScreenId}-${row.id}`}>
                          {assets.map((asset, idx) => {
                            {
                              return this.generatePreviewAsset(
                                asset,
                                idx,
                                rowId,
                                assets.length
                              );
                            }
                          })}
                        </PreviewRow>
                      );
                    })}
                  </React.Fragment>
                </PreviewContainer>
              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="blue-button start-lesson"
                  onClick={this.nextPage}
                >
                  Start Lesson
                </button>
              </div>
            </div>
          );
        } else {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <PreviewContainer
                  bgColor={currentscreen[keydisplaydata].background}
                >
                  <React.Fragment>
                    {rowOrder.map((rowId, idx) => {
                      const row = rows[rowId];
                      const assets = row.assets;
                      return (
                        <PreviewRow key={`${LessonScreenId}-${row.id}`}>
                          {assets.map((asset, idx) => {
                            {
                              return this.generatePreviewAsset(
                                asset,
                                idx,
                                rowId,
                                assets.length
                              );
                            }
                          })}
                        </PreviewRow>
                      );
                    })}
                  </React.Fragment>
                </PreviewContainer>
              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="lesson-preview--button blue-button"
                  onClick={this.previousPage}
                >
                  Back
                </button>
                <p className="current-screen">
                  Page {this.state.currentscreenidx + 1} of{" "} &nbsp;
                  {this.state.screens.length}
                </p>

                <button
                  className="lesson-preview--button blue-button"
                  onClick={this.nextPage}
                >
                  Next
                </button>
              </div>
            </div>
          );
        }
      } else if (currentscreen[keyscreentype] === 1) {
        return (
          <div className="lesson-preview--content">
            {this.showInteraction()}
          </div>
        );
      }
      // image
      else if (currentscreen[keyscreentype] === 3) {
        if (this.state.currentscreenidx === 0) {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-video-container">
                  <img
                    // style={{ width: "100%"}}

                    src={MEDIABASE + "assets/" + currentscreen[keyvideourl]}
                  >
                    {/* <BigPlayButton position="center" /> */}
                  </img>
                </div>
              </div>
              <button
                className="lesson-preview--button blue-button"
                onClick={this.nextPage}
              >
                Start Lesson
              </button>
            </div>
          );
        } else {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-video-container">
                  <img
                    // style={{ width: "100%" }}
                    // poster={MEDIABASE + "assets/" + "download.jpg"}
                    src={MEDIABASE + "assets/" + currentscreen[keyvideourl]}
                  >
                    {/* <BigPlayButton position="center" /> */}
                  </img>
                </div>
              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.previousPage}
                >
                  Back
                </button>

                <p className="current-screen">
                  Page {this.state.currentscreenidx + 1} of
                  {" " + this.state.screens.length}
                </p>

                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.nextPage}
                >
                  Next
                </button>
              </div>
            </div>
          );
        }
      }
      // video
      else if (currentscreen[keyscreentype] === 2) {
        if (this.state.currentscreenidx === 0) {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-video-container">
                  <Player
                    // style={{ height: "500" }}
                    playsInline={true}
                    // poster={MEDIABASE + "assets/" + "download.jpg"}
                    src={MEDIABASE + "assets/" + currentscreen[keyvideourl]}
                    height={640}
                    width={960}
                  >
                    {/* <BigPlayButton position="center" /> */}
                  </Player>
                </div>
              </div>
              <button
                className="lesson-preview--button blue-button"
                onClick={this.nextPage}
              >
                Start Lesson
              </button>
            </div>
          );
        } else {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-video-container">
                  <Player
                    playsInline={true}
                    // poster={MEDIABASE + "assets/" + "download.jpg"}
                    src={MEDIABASE + "assets/" + currentscreen[keyvideourl]}
                    height={640}
                    width={960}
                  >
                    <BigPlayButton position="center" />
                  </Player>
                </div>
              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.previousPage}
                >
                  Back
                </button>

                <p className="current-screen">
                  Page {this.state.currentscreenidx + 1} of
                  {" " + this.state.screens.length}
                </p>

                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.nextPage}
                >
                  Next
                </button>
              </div>
            </div>
          );
        }
      } else if (currentscreen[keyscreentype] === 4) {
        if (this.state.currentscreenidx === 0) {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-video-container">
                  <VideoPlayer
                    videoId={`https://player.vimeo.com/video/${currentscreen[keyvideourl]}`}
                    width="480px"
                    height="480px"
                  />
                </div>
              </div>
              <button
                className="lesson-preview--button blue-button"
                onClick={this.nextPage}
              >
                Start Lesson
              </button>
            </div>
          );
        } else {
          return (
            <div className="lesson-preview--content-wrapper">
              <div className="lesson-preview--content">
                <div className="lesson-video-container">
                  <VideoPlayer
                    videoId={`https://player.vimeo.com/video/${currentscreen[keyvideourl]}`}
                    width="100%"
                    height="100%"
                  />
                </div>
              </div>
              <div className="lesson-screens-navigation">
                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.previousPage}
                >
                  Back
                </button>

                <p className="current-screen">
                  Page {this.state.currentscreenidx + 1} of &nbsp;
                  {this.state.screens.length}
                </p>

                <button
                  className="lesson-preview--button lesson-preview--navigation blue-button"
                  onClick={this.nextPage}
                >
                  Next
                </button>
              </div>
            </div>
          );
        }
      } else {
        return <Loader />;
      }
    } else {
      return <SimpleLoader loaded={false} />;
    }
  }

  public navbuttons() {
    if (this.state.screens.length > 1) {
      return (
        <Col xs="12" md="12" sm="12" lg="12">
          <button style={{ marginRight: 9 }} onClick={this.previousPage}>
            Back
          </button>

          <button style={{ marginRight: 9 }} onClick={this.nextPage}>
            Next
          </button>

          <p>
            Page {this.state.currentscreenidx + 1} of{" "} &nbsp;
            {this.state.screens.length}
          </p>
        </Col>
      );
    } else {
      return (
        <div>
          <p />
        </div>
      );
    }
  }

  public goBack() {
    const currentD = currentDesignation() as string;
    const { history } = this.props;
    if (currentD === "admins") {
      // this.openWidget('singlelesson/' + this.currentid(), this)

      this.setState({
        destination: currentBaseUrl() + "lessons/" + this.currentid(),
        navigate: true,
      });
    } else {
      // this.setState({ destination: currentBaseUrl() + "lessons", navigate: true });
      this.setState({ openExitModal: true });
      // history.goBack();
    }
  }

  public exitPage() {
    const { history } = this.props;
    history.goBack();
  }

  public handleChooseTutor() {
    // set destination path to choose tutor component
    this.setState({
      destination: currentBaseUrl() + "singlelesson/choosetutor/",
      navigate: true,
    });
  }
  public rescheduleModal() {
    return (
      <Modal
        visible={this.state.openScheduleModal}
        effect="fadeInDown"
        onClickAway={this.closeScheduleModal}
      >
        <div className="lesson-modal-container">
          <div className="lesson-modal-content">
            <IoMdClose
              size="32px"
              onClick={this.closeScheduleModal}
              className="schedule-modal-close"
            />

            <div className="lesson-modal-body">
              <CustomCalendar
                scheduleEvts={this.state.events}
                onDragStop={this.onDragStop}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  public exitWarningModal() {
    return (
      <Modal
        visible={this.state.openExitModal}
        effect="fadeInDown"
        onClickAway={this.closeExitModal}
      >
        <div className="exit-modal-container">
          <p className="exit-warning">
            You will lose all progress if you exit this page now!
          </p>

          <div className="exit-warning-buttons">
            <button className="blue-button" onClick={this.exitPage}>
              Good to go
            </button>
            <button className="green-button" onClick={this.closeExitModal}>
              I'll stay
            </button>
          </div>
        </div>
      </Modal>
    );
  }
  public render() {
    // const lesson = currentLesson();
    const { lesson, downloadableFiles } = this.state;
    const keyscreentype = "ScreenType";
    if (this.state.tologin === true) {
      return <Redirect to="/login" />;
    }

    if (this.state.navigate === true) {
      return <Redirect to={this.state.destination} />;
    }
    return (
      <div className="lesson-preview--container">
        <NavBar logoutParent={this.onLogout} />
        <ToastContainer />
        <SimpleLoader loaded={this.state.loaded} />
        <Tour
          steps={tourSteps}
          isOpen={!this.state.guidesRead}
          onRequestClose={this.closeTour}
          onAfterOpen={this.disableBody}
          onBeforeClose={this.enableBody}
          accentColor="#ff0033"
        />

        {this.rescheduleModal()}
        {this.exitWarningModal()}
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="lesson-preview--screen-content">
            <div className="lesson-preview--header">
              <p className="go-back" onClick={this.goBack}>
                &lt; Exit
              </p>
            </div>
            <div className="lesson-preview--content-container">
              <div
                style={{ paddingTop: "4em" }}
                className="lesson-tile--wrap step-1"
              >
                {/* <h2 className="lesson-title" style={{ marginBottom: "2em" }}>
                  <span>{`${lesson.Name}`}:</span>
                </h2> */}
                {this.screendisplay2(this.state.currentscreen)}
              </div>

              <div className="lesson-preview--content-sidebar step-2">
                <div className="lesson-preview--content-sidebar-nav">
                  <h6>Your Performance Learning Pathways</h6>
                  <Scrollbars
                    className="school-res-disparea"
                    style={{
                      height: "55vh",
                      backgroundColor: "#1a1a1a",
                      padding: "0.5em",
                    }}
                  >
                    <Steps
                      direction="vertical"
                      current={this.state.currentscreenidx}
                    // size="small"
                    >
                      {this.state.screens.map((screen) => {
                        const title = `${screen.Title[0].toUpperCase()}${screen.Title.toLowerCase().slice(
                          1
                        )}`;

                        return (
                          <Step
                            key={screen.id}
                            title={title}
                            disabled={
                              screen[keyscreentype] === 1 ? true : false
                            }
                          />
                        );
                      })}
                    </Steps>
                  </Scrollbars>
                </div>

                {
                  downloadableFiles.length ? (<div style={{
                    paddingLeft: '1em',
                  }} className="lesson-preview--content-sidebar-summary">
                    <h4 style={{ marginTop: 0, fontSize: '20px' }}>Your Worksheet</h4>
                    <a
                      style={{ color: "#acff24", textDecoration: 'none' }}
                      href={`${MEDIABASE}assets/${downloadableFiles[0].FileName}`}
                      download={`${lesson.Name} Lesson Worksheet.pdf`}
                    >
                      Click here to download
                    </a>
                  </div>) : ""
                }
              </div>
            </div>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default withServices(LessonViewPage);



// WEBPACK FOOTER //
// ./src/pages/SingleLesson/lessonViewPage.Component.tsx